import type { RUICHeadingVariants, SBHeadingVariants } from "./Heading.d";

const headingVarinats: Record<SBHeadingVariants, RUICHeadingVariants | "capitals"> = {
  "1": "h1",
  "2": "h2",
  "3": "h3",
  "4": "h4",
  "5": "h5",
  "6": "capitals",
};

export default headingVarinats;
